document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() { if (drawer) drawer.classList.add('is-open'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); closeMobileNav(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!btn.hasAttribute('href')) e.preventDefault();
      closeDrawer();
    });
  });

  /* ---------- Mobile off-canvas nav open/close ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var navToggle = document.querySelector('[data-nav-open]');
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
  }
  if (navToggle) navToggle.addEventListener('click', function (e) { e.preventDefault(); openMobileNav(); });
  document.querySelectorAll('[data-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!btn.hasAttribute('href')) e.preventDefault();
      closeMobileNav();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMobileNav(); closeDrawer(); }
  });

  /* ---------- Rebuild cart drawer items from /cart.js (JSON) ---------- */
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        openDrawer();
      })
      .catch(function () {});
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '' +
          '<div class="cart-line cart-line--drawer" data-cart-line>' +
            '<div class="cart-line__media">' + (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') + '</div>' +
            '<div class="cart-line__body">' +
              '<div class="cart-line__title">' + item.product_title + '</div>' +
              '<div class="cart-line__variant">' + item.variant_title + '</div>' +
              '<div class="cart-line__row">' +
                '<div class="qty-stepper qty-stepper--sm">' +
                  '<button type="button" data-qty-minus aria-label="Restar">&minus;</button>' +
                  '<input type="number" min="0" value="' + item.quantity + '" class="qty-input qty-input--sm" data-cart-qty="' + item.key + '">' +
                  '<button type="button" data-qty-plus aria-label="Sumar">+</button>' +
                '</div>' +
                '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Eliminar producto">&times;</button>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var formatted = parts[0] + ',' + parts[1];
    var format = window.themeMoneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*amount\w*\s*\}\}/, formatted);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; }

      // A size per pair: one cart line per distinct size, so the quantity discount still adds up across them.
      var pairSelects = form.querySelectorAll('[data-pair-size]');
      var request;
      if (pairSelects.length) {
        var counts = {};
        var order = [];
        pairSelects.forEach(function (select) {
          if (!counts[select.value]) { counts[select.value] = 0; order.push(select.value); }
          counts[select.value]++;
        });
        request = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: order.map(function (id) { return { id: Number(id), quantity: counts[id] }; }) })
        });
      } else {
        request = fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      }

      request
        .then(function (res) { return res.json(); })
        .then(function () {
          updateCartCount();
          refreshCartDrawer();
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; }
        });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- Cart line quantity change ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty]')) {
      var input = e.target;
      var key = input.getAttribute('data-cart-qty');
      var qty = parseInt(input.value, 10) || 0;
      var inDrawer = !!input.closest('[data-cart-drawer]');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (inDrawer) {
            renderDrawer(cart);
          } else {
            window.location.reload();
          }
        });
    }
  });

  /* ---------- Cart line remove ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var line = removeBtn.closest('[data-cart-line]');
    var input = line ? line.querySelector('[data-cart-qty]') : null;
    if (input) {
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variantsJSON = picker.getAttribute('data-variants');
    var variants = [];
    try { variants = JSON.parse(variantsJSON); } catch (err) { variants = []; }
    var form = picker.closest('[data-product-form]');
    var idInput = form ? form.querySelector('[data-variant-id-input]') : null;
    var priceEl = form ? form.parentElement.querySelector('[data-product-price]') : null;
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var stickyPriceEl = document.querySelector('[data-sticky-atc-price]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');

    function selectedOptions() {
      var groups = picker.querySelectorAll('[data-option-index]');
      var options = [];
      groups.forEach(function (group) {
        var active = group.querySelector('.variant-pill.is-selected');
        options.push(active ? active.getAttribute('data-value') : null);
      });
      return options;
    }

    function findVariant() {
      var options = selectedOptions();
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      var comparePriceEl = document.querySelector('[data-product-compare-price]');
      var discountBadgeEl = document.querySelector('[data-product-discount-badge]');
      if (variant.compare_at_price > variant.price) {
        if (comparePriceEl) { comparePriceEl.textContent = formatMoney(variant.compare_at_price); comparePriceEl.style.display = ''; }
        if (discountBadgeEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          discountBadgeEl.textContent = '-' + pct + '% OFF';
          discountBadgeEl.style.display = '';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (discountBadgeEl) discountBadgeEl.style.display = 'none';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-label-add') : 'Agotado';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Agregar' : 'Agotado';
      }
    }

    picker.querySelectorAll('.variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-option-index]');
        group.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        updateUI();
      });
    });

    updateUI();
  });

  /* ---------- Product gallery: click-to-swap on desktop, native swipe carousel on mobile ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__gallery-slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!track || slides.length < 2) return;

    function setActive(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setActive(i);
        if (window.matchMedia('(max-width: 600px)').matches && slides[i]) {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        }
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        if (!track.clientWidth) return;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, index)));
      }, 100);
    }, { passive: true });
  });

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  var mainAtcBtn = document.querySelector('[data-add-to-cart]');
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (mainAtcBtn && stickyAtc && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 });
    atcObserver.observe(mainAtcBtn);
  }

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-qty-plus]')) {
      var input = e.target.parentElement.querySelector('input');
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (e.target.matches('[data-qty-minus]')) {
      var input2 = e.target.parentElement.querySelector('input');
      input2.value = Math.max(1, (parseInt(input2.value, 10) || 1) - 1);
      input2.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Quantity discount tiers ---------- */
  document.querySelectorAll('[data-qty-tiers]').forEach(function (tiers) {
    var form = tiers.closest('form');
    var qtyInput = tiers.parentElement.querySelector('[data-qty-tier-input]');
    var options = tiers.querySelectorAll('.qty-tier');
    var pairBox = form ? form.querySelector('[data-pair-sizes]') : null;
    var pairList = pairBox ? pairBox.querySelector('[data-pair-sizes-list]') : null;
    var sizeOptions = pairBox ? pairBox.querySelector('template[data-pair-size-options]') : null;
    var idInput = form ? form.querySelector('[data-variant-id-input]') : null;
    var pairTitle = pairBox ? pairBox.querySelector('[data-pair-sizes-title]') : null;

    // Keeps the plain form field in step with pair 1, so a non-ajax submit still adds the right size.
    function syncIdInput() {
      var first = pairList ? pairList.querySelector('select') : null;
      if (idInput && first) idInput.value = first.value;
    }

    // Pair 1 leads: pairs the customer hasn't touched follow its size.
    function onPairChange() {
      var selects = pairList.querySelectorAll('select');
      if (this === selects[0]) {
        selects.forEach(function (s, idx) {
          if (idx > 0 && s.dataset.touched !== '1') s.value = selects[0].value;
        });
      } else {
        this.dataset.touched = '1';
      }
      syncIdInput();
    }

    // One size selector per pair (a single "Talle" selector when buying one pair).
    function renderPairs(count) {
      if (!pairBox || !pairList || !sizeOptions) return;
      pairBox.hidden = !sizeOptions.innerHTML.trim();
      var previous = Array.prototype.map.call(pairList.querySelectorAll('select'), function (s) {
        return { value: s.value, touched: s.dataset.touched === '1' };
      });
      pairList.innerHTML = '';
      pairList.classList.toggle('pair-sizes__list--single', count === 1);
      for (var i = 1; i <= count; i++) {
        var row = document.createElement('label');
        row.className = 'pair-sizes__row';
        var name = document.createElement('span');
        name.textContent = count === 1 ? 'Talle' : 'Par ' + i;
        var select = document.createElement('select');
        select.setAttribute('data-pair-size', '');
        select.innerHTML = sizeOptions.innerHTML;
        var prev = previous[i - 1];
        if (prev) {
          select.value = prev.value;
          if (prev.touched) select.dataset.touched = '1';
        } else if (i > 1) {
          select.value = pairList.querySelector('select').value;
        }
        select.addEventListener('change', onPairChange);
        row.appendChild(name);
        row.appendChild(select);
        pairList.appendChild(row);
      }
      if (pairTitle) pairTitle.textContent = count > 1 ? 'Elegí el talle de cada par' : 'Elegí tu talle';
      syncIdInput();
    }

    function applyTier(radio) {
      if (qtyInput) qtyInput.value = radio.value;
      options.forEach(function (opt) { opt.classList.toggle('is-selected', opt.contains(radio)); });
      renderPairs(parseInt(radio.value, 10) || 1);
    }

    tiers.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) applyTier(e.target);
    });

    var checkedTier = tiers.querySelector('input[type="radio"]:checked');
    if (checkedTier) applyTier(checkedTier);
  });
});
